import { resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { BankHoliday } from './BankHoliday';

export const BankHolidayDate = types.compose(
  BaseEntity,
  types
    .model('BankHolidayDate', {
      bankHolidayDateId: types.identifierNumber,
      bankHolidayId: types.integer,
      date: types.string,
    })
    .views((self) => {
      return {
        get bankHoliday() {
          if (self.bankHolidayId) {
            return resolveIdentifier(BankHoliday, self, self.bankHolidayId);
          } else {
            return null;
          }
        },
      };
    }),
);
